import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Field } from "./Common";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Checkbox } from "./ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function ContactImport({ onDone }) {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [tag, setTag] = useState("");
  const [cc, setCc] = useState("44");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const content = await file.text();
      const { data } = await api.post("/marketing/contacts/import", { filename: file.name, content, tag, consent, country_code: cc }, { timeout: 300000 });
      toast.success(`${data.created} new · ${data.updated} already in Bloomwell · ${data.skipped} skipped`);
      setOpen(false); setFile(null); onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" className="rounded-full" data-testid="import-contacts-btn" onClick={() => setOpen(true)}><Upload className="h-4 w-4 mr-1.5" />Import contacts</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="import-contacts-dialog">
          <DialogHeader><DialogTitle>Import contacts</DialogTitle></DialogHeader>
          <div className="space-y-4 text-sm">
            <p className="text-muted-foreground">Upload a <b>.vcf</b> file (iPhone: Contacts → select contacts → Share/Export) or a <b>.csv</b> export from Whazzend, Excel or Google Contacts with name, phone and email columns. People already in Bloomwell are matched by phone or email, so nobody is duplicated.</p>
            <Field label="File"><Input type="file" accept=".vcf,.csv,.txt" data-testid="import-file" onChange={(e) => setFile(e.target.files?.[0] || null)} /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Tag (optional)"><Input data-testid="import-tag" value={tag} placeholder="iphone" onChange={(e) => setTag(e.target.value)} /></Field>
              <Field label="Country code for numbers without +"><Input data-testid="import-cc" value={cc} onChange={(e) => setCc(e.target.value.replace(/\D/g, "").slice(0, 3))} /></Field>
            </div>
            <label className="flex items-start gap-2"><Checkbox data-testid="import-consent" checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5" />
              <span>These people agreed to receive offers from us. Required before they can get campaigns; Bloomwell records the date and source.</span></label>
            <Button className="rounded-full" data-testid="import-run" disabled={!file || busy} onClick={run}>{busy ? "Importing…" : "Import"}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
